export class UnknownError extends Error {
  public readonly statusCode: number;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(error: any) {
    const dataArray = error?.response?.data;

    const message =
      Array.isArray(dataArray) && dataArray.length > 0
        ? dataArray[0]
        : error.message;

    super(message);

    this.name = 'UnknownError';

    this.statusCode = error?.response?.status ?? 500;

    if (error.stack) {
      this.stack = error.stack;
    }
  }
}
